import { render, staticRenderFns } from "./ChannelTriggers.vue?vue&type=template&id=99e514aa"
import script from "./ChannelTriggers.vue?vue&type=script&lang=js"
export * from "./ChannelTriggers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports